<div class="circle">

    <div  [ngClass]="red"></div>
     <div [ngClass]="red1"></div>


    <div [ngClass]="green"></div>
  <div [ngClass]="green1"></div>

    <div [ngClass]="blue"></div>
  <div [ngClass]="blue1"></div>

</div>
